/**
 * WAS BEIM ÖFFNEN DER KARTE ANGEHAKT IST - und sonst nichts.
 *
 * ORIGINALTEXT MARVIN (04.09.2026)
 *   „also nochmal zur klarheit. beide Bereiche mit Lageplan vorbereiten für
 *    die gemeinde und planung für den tiefbau hat die gleiche kartenstruktur
 *    mit allem. es unterscheidet sich nur in dem was markiert ist beim starten
 *    und die symbole zur anzeichnung!"
 *
 * ORIGINALTEXT MARVIN (08.09.2026)
 *   „Lageplan: was oben angehakt ist (z. B. Straßennamen mit Hausnummern),
 *    muss beim Erzeugen mit auf das Blatt"
 *
 * **DER ZWEITE SATZ IST DER GRUND, WARUM DIESE DATEI KEIN JSX MEHR DANEBEN
 * HAT.** Die vier Haken entscheiden ab .144 nicht mehr nur, was das FENSTER
 * zeigt, sondern auch, was auf dem BLATT an die Gemeinde steht - und die
 * Vorgabe des Blattes (`BLATT_VORGABE` in `api/src/regeln/blattlagen.ts`) ist
 * damit die zweite Fassung derselben vier Werte. Zwei Fassungen laufen beim
 * ersten Nachtrag auseinander, und dann bekäme die Gemeinde ein anderes Papier
 * als den Bildschirm.
 *
 * Sie standen bis dahin in `Kartenflaeche.tsx`, also in einer Datei mit JSX -
 * und die lässt sich mit `--experimental-strip-types` nicht laden. **Eine
 * Textsuche misst, dass etwas dasteht, nicht, dass es stimmt**, und genau
 * diese vier Werte muss man nebeneinanderlegen können. Prüfstand 125 tut es.
 *
 * Sechzehnte Datei dieser Art nach `namen.ts`, `terminraster.ts`,
 * `klebeband.ts`, `kartenmass.ts`, `oberflaeche.ts`, `kartenebene.ts`,
 * `grenzpunkte.ts`, `handbuchmarken.ts`, `tabellenbeschriftung.ts`,
 * `zahlwoerter.ts`, `bruchstellen.ts`, `anlasstext.ts`, `technikfelder.ts`,
 * `grabenlaenge.ts` und `ereignisquelle.ts`.
 */

/** Die vier Haken über der Karte. */
export interface Kartenschalter {
  /** Das Luftbild als Grund. Ohne ihn liegt die Straßenkarte darunter. */
  luftbild: boolean;
  /** Straßennamen und Hausnummern über dem Luftbild. */
  schrift: boolean;
  /** Die amtlichen Flurstücksgrenzen. */
  grenzen: boolean;
  /** Die Flurstücksnummern dazu. Ohne Grenzen gibt es sie nicht. */
  nummern: boolean;
}

/**
 * DIE VORBELEGUNG DES LAGEPLANS - das Papier, das an die Gemeinde geht.
 *
 * ORIGINALTEXT MARVIN (03.09.2026)
 *   „außerdem lass bei dem Lageplan für den Tiefbau dierek die funktion
 *    «LuftbilD» aktiviert."
 *
 * ORIGINALTEXT MARVIN (02.09.2026)
 *   „bei dieser ansicht brauchen die grundstücksgrenzen und flurnummern nicht
 *    automatisch aktiv sein"
 *
 * **DIESELBEN VIER WERTE WIE `BLATT_VORGABE` IM SERVER.** Wer die Karte
 * gerade erst geöffnet hat, sieht genau das, was ein Werkzeug bekommt, das
 * die Haken gar nicht mitschickt.
 */
export const START_LAGEPLAN: Kartenschalter = {
  luftbild: true, schrift: true, grenzen: false, nummern: false,
};

/**
 * DIE VORBELEGUNG DER PLANUNG - die Zeichnung, die im Haus bleibt.
 *
 * ORIGINALTEXT MARVIN (03.09.2026)
 *   „bei der planung soll luftbild und grenzen aktiv sein und direkt die
 *    montagegrube ausgewählt."
 *
 * Hier wird über fremden Grund gezeichnet, und **wo die Grundstücksgrenze
 * verläuft, entscheidet, wo gegraben werden darf.** Die NUMMERN bleiben auch
 * hier aus: sie legen sich als Wand aus Ziffern über genau die Fläche, die
 * abgetastet wird.
 */
export const START_PLANUNG: Kartenschalter = {
  luftbild: true, schrift: true, grenzen: true, nummern: false,
};
